module.exports = __webpack_public_path__ + "img/8.a92c3772.png";